(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Adds 'Back to top' functionality to an element with the ID 'back-to-top'
 * @example 
 * 1. Create a link-wrapper with ID 'back-to-top'
 * 2. Add an icon inside the link-wrapper such as an arrow
 * 3. Set position fixed: bottom right
 * 4. Set opacity to 0
 */
var BackToTop =
/*#__PURE__*/
function () {
  function BackToTop() {
    _classCallCheck(this, BackToTop);

    this.$backToTop = $('#back-to-top');
    this.toggleDistance = 50;

    if (this.$backToTop.length > 0) {
      this.init();
    }
  }

  _createClass(BackToTop, [{
    key: "init",
    value: function init() {
      var _this = this;

      window.onscroll = function () {
        return _this.scrollFunction();
      };

      this.$backToTop.on('click', function () {
        return _this.scrollToTop();
      });
    }
  }, {
    key: "scrollFunction",
    value: function scrollFunction() {
      if (document.body.scrollTop > this.toggleDistance || document.documentElement.scrollTop > this.toggleDistance) {
        this.$backToTop.css({
          'opacity': '1',
          'cursor': 'pointer',
          'pointer-events': 'all'
        });
      } else {
        this.$backToTop.css({
          'opacity': '0',
          'cursor': 'default',
          'pointer-events': 'none'
        });
      }
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      window.scrollTo(0, 0);
    }
  }]);

  return BackToTop;
}();

var _default = BackToTop;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */
var FeatherlightModals =
/*#__PURE__*/
function () {
  function FeatherlightModals() {
    _classCallCheck(this, FeatherlightModals);

    // Check if exists and initialize
    this.$image_modals = $('a[data-elementor-open-lightbox]');
    this.$oe_lightbox_images = $('a.oxy-carousel-builder_gallery-image');
    this.$featherlight_galleries = $('.js-featherlight-gallery');
    this.hasImageModals = this.$image_modals.length > 0;
    this.hasOELightboxImages = this.$oe_lightbox_images.length > 0;
    this.hasGalleries = this.$featherlight_galleries.length > 0;

    if ((this.hasImageModals || this.hasOELightboxImages || this.hasGalleries) && typeof $.featherlight == 'function') {
      this.init();
    }
  }

  _createClass(FeatherlightModals, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      if (this.hasImageModals) {
        $.featherlight(this.$image_modals);
      }

      if (this.hasGalleries) {
        this.$featherlight_galleries.each(function (i, el) {
          $(el).find('.js-gallery-image').featherlightGallery({
            gallery: {
              previous: '«',
              next: '»',
              fadeIn: 300
            }
          });
        });
      } // if( this.hasOELightboxImages ){
      //     $.featherlight( this.$oe_lightbox_images );
      // }

    }
  }]);

  return FeatherlightModals;
}();

var _default = FeatherlightModals;
exports.default = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FindPropertyForm =
/*#__PURE__*/
function () {
  function FindPropertyForm() {
    _classCallCheck(this, FindPropertyForm);

    this.priceSlider = document.getElementById('slider');

    if (this.priceSlider !== null) {
      this.init();
    }
  }

  _createClass(FindPropertyForm, [{
    key: "init",
    value: function init() {
      var _this = this;

      // this.priceSlider = document.getElementById('slider');
      noUiSlider.create(this.priceSlider, {
        start: [800000, 1250000],
        connect: true,
        range: {
          'min': 100000,
          'max': 2000000
        },
        step: 50000,
        format: wNumb({
          decimals: 0,
          thousand: ',',
          prefix: '$ '
        })
      });
      this.$priceRangeDisplay = $('#price-range');
      var minPrice = $('input[name="pf_min_price"]').get(0);
      var maxPrice = $('input[name="pf_max_price"]').get(0);
      this.priceSlider.noUiSlider.on('update', function (values, handle) {
        var value = values[handle];

        if (values[1] == "$ 2,000,000") {
          values[1] = values[1] + "+";
          value = values[1];
        }

        if (handle == 0) {
          minPrice.value = value;
        } else {
          maxPrice.value = value;
        }

        _this.$priceRangeDisplay.text(values[0] + " - " + values[1]);
      });
      this.$optionBoxes = $('.option-boxes .ff-el-form-check label');
      this.$optionBoxes.on('click', function (e) {
        return _this.handleRadioOptionClick(e, _this.$optionBoxes);
      }); // this.$bedroomOptions = $('.option-boxes.bedrooms .ff-el-form-check label');
      // this.$bathroomOptions = $('.option-boxes.bathrooms .ff-el-form-check label');
      // this.$timeframeOptions = $('.option-boxes.timeframe .ff-el-form-check label');
      // this.$bedroomOptions.on( 'click', (e) => this.handleRadioOptionClick(e, this.$bedroomOptions) );
      // this.$bathroomOptions.on( 'click', (e) => this.handleRadioOptionClick(e, this.$bathroomOptions) );
      // this.$timeframeOptions.on( 'click', (e) => this.handleRadioOptionClick(e, this.$timeframeOptions) );
    }
  }, {
    key: "handleRadioOptionClick",
    value: function handleRadioOptionClick(e, $options) {
      $options.removeClass('active');
      $(e.currentTarget).addClass('active');
    }
  }]);

  return FindPropertyForm;
}();

var _default = FindPropertyForm;
exports.default = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Single Floor Plan JS
 * @example 
 * 
 */
var SingleFloorPlan =
/*#__PURE__*/
function () {
  function SingleFloorPlan() {
    _classCallCheck(this, SingleFloorPlan);

    this.$propertyFpSelector = $('#property_fp');
    this.$fpBottomSectionSelector = $('.fp_bottom_section img');
    this.$fpMiddleSectionSelector = $('.fp_middle_section img.main-fp-img');

    if (this.$propertyFpSelector.length > 0) {
      this.init();
    }
  }

  _createClass(SingleFloorPlan, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.$propertyFpSelector.on('change', function (e) {
        _this.handleMainContent(e);
      });
      this.$fpBottomSectionSelector.on('click', function (e) {
        _this.handleBottomSection(e);
      });
      this.$fpMiddleSectionSelector.on('click', function (e) {
        _this.handleMiddleSection(e);
      });
    }
  }, {
    key: "handleMainContent",
    value: function handleMainContent(e) {
      var prop_id = $(e.target).val();
      jQuery('.fp_main_content').hide();
      jQuery('#fp_main_content_' + prop_id).show();
      var $carousel = $('.carousel').flickity();
      $carousel.flickity('resize');
    }
  }, {
    key: "handleBottomSection",
    value: function handleBottomSection(e) {
      var prop_img = $(e.target).attr('data-src'); //let prop_img = e.currentTarget.currentSrc;       

      var main_parent_id = $(e.target).parent().parent().prop('id');
      jQuery('#' + main_parent_id).find('.fp_middle_section img').attr("src", prop_img);
    }
  }, {
    key: "handleMiddleSection",
    value: function handleMiddleSection(e) {
      var main_parent_id = $(e.target).parent().parent().prop('id');
      jQuery('#' + main_parent_id).find('.fp_middle_section .custom-fp-modal-popup').addClass('live');
      jQuery('#' + main_parent_id).find('.fp_middle_section .custom-fp-modal-popup.live').css('display', 'block');
    }
  }]);

  return SingleFloorPlan;
}();

var _default = SingleFloorPlan;
exports.default = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Opens social sharing links in a small popup window
 * @example 
 * 1. Add the class .js-social-share-popup to social share links
 */
var SocialSharePopups =
/*#__PURE__*/
function () {
  function SocialSharePopups() {
    _classCallCheck(this, SocialSharePopups);

    // Check if exists and initialize
    this.$socialShareLinks = $('.js-social-share-popup');
    this.viewportMinSize = 768;

    if (this.$socialShareLinks.length > 0 && $(window).width() > this.viewportMinSize) {
      this.init();
    }
  }

  _createClass(SocialSharePopups, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)
      console.log('social popups initialized');
      this.$socialShareLinks.on('click', function (e) {
        return _this.handleSocialShareLinkClick(e);
      });
    }
  }, {
    key: "handleSocialShareLinkClick",
    value: function handleSocialShareLinkClick(e) {
      e.preventDefault();
      var targetUrl = $(e.currentTarget).attr('href');
      var newWin = window.open(targetUrl, 'sharewindow', 'width=600,height=400');
    }
  }]);

  return SocialSharePopups;
}();

var _default = SocialSharePopups;
exports.default = _default;

},{}],6:[function(require,module,exports){
"use strict";

var _backToTop = _interopRequireDefault(require("./modules/back-to-top"));

var _socialSharePopups = _interopRequireDefault(require("./modules/social-share-popups"));

var _singleFloorPlan = _interopRequireDefault(require("./modules/single-floor-plan"));

var _featherlightModals = _interopRequireDefault(require("./modules/featherlight-modals"));

var _findPropertyForm = _interopRequireDefault(require("./modules/find-property-form"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */
// import $ from 'jquery';
window.$ = jQuery;
$(document).ready(function () {
  $('html').addClass('js-on-load');
  var backToTop = new _backToTop.default();
  var socialSharePopups = new _socialSharePopups.default();
  var singleFloorPlan = new _singleFloorPlan.default();
  var featherlightModals = new _featherlightModals.default();
  var findPropertyForm = new _findPropertyForm.default(); // plugin('ResponsiveTabs', ResponsiveTabs);
});

},{"./modules/back-to-top":1,"./modules/featherlight-modals":2,"./modules/find-property-form":3,"./modules/single-floor-plan":4,"./modules/social-share-popups":5}]},{},[6]);
